import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    CommentType,
} from 'app/shared-components/CommentsLog/CommentsLog.types'

import requestConfig from 'app/requests/GatewayComment.requests'

const useGetGatewayComments = (gatewayId: number) => {
    return useRequestTable<CommentType>({
        key: RequestKeys.getGatewayComments,
        params: {
            gatewayId,
        },
        config: requestConfig.filterRequestAll,
        keepPreviousData: true,
    })
}

export default useGetGatewayComments
